import { GRAY_COLORS } from '../globalTheme';

export const theme = {
	menu: {
		borderTop: `1px solid ${GRAY_COLORS.gray100}`
	},
	header: {
		padding: '10px',
		borderBottom: `1px solid ${GRAY_COLORS.gray100}`,
		borderTop: 'none',
		fontWeight: 600
	}
};
